/**
 * Visibility flags for unified order-summary layout sections.
 * Variants only control which slots render — not data fetching or business rules.
 */

export const HR_ORDER_VARIANT = {
  FLIGHT: "flight",
  PACKAGE: "package",
  HOTEL: "hotel",
  PROPOSAL: "proposal",
  SUCCESS: "success",
};

const DEFAULT_SECTIONS = {
  header: true,
  overview: true,
  travel: true,
  passengers: true,
  services: true,
  pricingMain: true,
  notes: true,
  summaryPanel: true,
  mobileBar: true,
};

const VARIANT_SECTIONS = {
  [HR_ORDER_VARIANT.PROPOSAL]: {
    ...DEFAULT_SECTIONS,
    pricingMain: false,
  },
  [HR_ORDER_VARIANT.FLIGHT]: {
    ...DEFAULT_SECTIONS,
    pricingMain: false,
  },
  [HR_ORDER_VARIANT.PACKAGE]: {
    ...DEFAULT_SECTIONS,
    pricingMain: true,
  },
  [HR_ORDER_VARIANT.HOTEL]: {
    ...DEFAULT_SECTIONS,
    pricingMain: true,
    passengers: false,
    services: false,
  },
  [HR_ORDER_VARIANT.SUCCESS]: {
    ...DEFAULT_SECTIONS,
    mobileBar: false,
    summaryPanel: true,
  },
};

/**
 * @param {string} variant — one of HR_ORDER_VARIANT.*
 * @returns {Record<string, boolean>}
 */
export function getHrOrderSectionVisibility(variant) {
  return VARIANT_SECTIONS[variant] || DEFAULT_SECTIONS;
}
